import Loader from "components/shared/loader";
import { assistantChatReportTypesEnum } from "helpers/enums";
import { ymEvent } from "helpers/system";
import LogoLong from "logo-long.svg";
import React, { useEffect, useState } from "react";
import { getReport } from "sources/assistantChat";
import * as ReportPartials from "./partials";

const metricEvents = {
    open: {
        [assistantChatReportTypesEnum.EveryWeekStatistic]: "EveryWeekStatisticOpened",
        [assistantChatReportTypesEnum.InvolvementAnalysis]: "InvolvementAnalysisOpened",
        [assistantChatReportTypesEnum.EveryWeekRefuelingStatistic]: "EveryWeekRefuelingStatisticOpened",
        [assistantChatReportTypesEnum.MonthResult]: "MonthResultOpened",
    },
    download: {
        [assistantChatReportTypesEnum.EveryWeekStatistic]: "EveryWeekStatisticDownloaded",
        [assistantChatReportTypesEnum.InvolvementAnalysis]: "InvolvementAnalysisDownloaded",
        [assistantChatReportTypesEnum.EveryWeekRefuelingStatistic]: "EveryWeekRefuelingStatisticDownloaded",
        [assistantChatReportTypesEnum.MonthResult]: "MonthResultDownloaded",
    },
};

const reportSources = {
    assistant: "assistant",
    email: "email",
};

const sourceMetricEvents = {
    open: {
        [assistantChatReportTypesEnum.EveryWeekRefuelingStatistic]: {
            [reportSources.assistant]: "EveryWeekRefuelingStatisticOpenedFromAssistant",
            [reportSources.email]: "EveryWeekRefuelingStatisticOpenedFromEmail",
        },
    },
    download: {
        [assistantChatReportTypesEnum.EveryWeekRefuelingStatistic]: {
            [reportSources.assistant]: "EveryWeekRefuelingStatisticDownloadedFromAssistant",
            [reportSources.email]: "EveryWeekRefuelingStatisticDownloadedFromEmail",
        },
    },
};

const getReportSource = (search = "") => {
    const params = new URLSearchParams(search);

    return params.get("source") === reportSources.assistant ? reportSources.assistant : reportSources.email;
};

const sendReportMetricEvent = (eventType, reportType, source) => {
    ymEvent(metricEvents[eventType][reportType]);

    const sourceEventName = sourceMetricEvents[eventType][reportType]?.[source];
    if (sourceEventName) {
        ymEvent(sourceEventName);
    }
};

export default function AssistantChatReport(props) {
    const { reportType, messageId } = props.match.params;
    const reportSource = getReportSource(props.location?.search);

    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        sendReportMetricEvent("open", reportType, reportSource);
        getReport(reportType, messageId).then((res) => {
            setData(res);
            setLoading(false);
        });
        document.body.classList.add("no-overflow");
        return () => document.body.classList.remove("no-overflow");
    }, []);

    if (loading) {
        return (
            <div className="page-loader-wrap">
                <Loader />
            </div>
        );
    }

    const renderReport = () => {
        const ReportComponent = ReportPartials[reportType];
        return <ReportComponent data={data} />;
    };

    return (
        <div className="a-report">
            <div className="a-report__table-wrap">
                <div
                    className="btn btn-sm btn-outline-primary no-print my-2"
                    onClick={() => {
                        sendReportMetricEvent("download", reportType, reportSource);
                        window.print();
                    }}
                >
                    <i className="icon-uEA12-print icon-inline pr-1" />
                    Печать
                </div>
                <div className="a-report__head">
                    <div className="a-report__head-left">
                        <div className="a-report__head-left--text">
                            {reportType === assistantChatReportTypesEnum.MonthResult ? "ЕЖЕМЕСЯЧНЫЙ" : "ЕЖЕНЕДЕЛЬНЫЙ"}
                            <br /> ОТЧЕТ
                        </div>
                    </div>
                    <div className="a-report__head-right">
                        <LogoLong className="a-report__head-right--logo" />
                    </div>
                </div>
                {renderReport()}
            </div>
        </div>
    );
}
